var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartCarouselAnimation3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHeartCarouselAnimation3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.05273061,1.13192247 C-0.351714184,2.64044328 -0.35010599,5.06211316 1.05273061,6.5718276 L6.78099884,12.7377083 C6.83725537,12.7987492 6.91551084,12.8333333 6.99737539,12.8333333 C7.07923995,12.8333333 7.15749542,12.7987492 7.21375195,12.7377083 C9.12500129,10.684804 11.0354021,8.62956139 12.9466664,6.57661129 C14.3511112,5.06806449 14.3511112,2.64524377 12.9466664,1.13669851 C11.5422364,-0.371845223 9.24640505,-0.371878846 7.84196022,1.13669851 L6.99969834,2.03937086 L6.15745136,1.13192247 C5.4552215,0.377649836 4.5272935,1.73751474e-14 3.60276059,1.73751474e-14 C2.67822768,0 1.75494558,0.377648307 1.05273061,1.13192247 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icHeartCarouselAnimation3",
    fill: "#7EC34D",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartCarouselAnimation3);
export default __webpack_public_path__ + "static/media/icHeartCarouselAnimation3.1e163064f2ace5db7d9e93487407fa2b.svg";
export { ForwardRef as ReactComponent };